var Configurator = {
  $modal: $('#product-configurator'),
  $configurator: $('.product-configurator'),
  $gallery: $('.product-configurator__gallery'),
  $choicesTrigger: $('[data-toggle="choices"]'),
  $choicesClose: $('.option-choices-close'),
  $choicesApply: $('.option-choices-apply'),
  baseCode: "-",
  basePrice: 0.00,
  discount: 0,
  options: {},
  choicesCarousel: false,
  choicesGrid: false,
  init: function(config) {
    Configurator.compact = config.compact || false;
    Configurator.baseCode = config.product.code;
    Configurator.basePrice = parseFloat(config.product.price);
    Configurator.discount = parseFloat(config.product.discount);
    Configurator.setOptions(config.options);

    Configurator.bindEvents();
    Configurator.updateProductIntroOptions();

    if ($(window).width() < 992) {
      if (isMobile) {
        Configurator.initChoicesCarousel();
      }
    } else {
      Configurator.initChoicesGrid();
    }

    // temp
    // $('[data-toggle="configure"]').trigger('click');
  },
  bindEvents: function(){
    $(document).on('click', '[data-toggle="configure"]', function() {
      Configurator.show();
    });

    $('.product-options__checkbox [type="checkbox"]').on('click', function(e){
      Configurator.selectCheckbox($(this).closest('.product-options__entry'));
    });

    $('.option-choices__entry').on('click', function() {
      Configurator.selectChoice($(this));
    });

    Configurator.$choicesTrigger.on('click', function(e) {
      e.preventDefault();
      Configurator.showChoices($(this));
    });

    Configurator.$modal.on('shown.bs.modal', function() {
      Configurator.initGallery();
    });

    $('.option-choices__apply').on('click', function() {
      Configurator.applyChoice();
    });

    $('.option-choices__close').on('click', function() {
      Configurator.closeChoices();
    });

    $('.product-configurator__apply').on('click', function() {
      Configurator.applyConfigurations();
    });
  },
  setOptions: function(options){
    Configurator.options = options;
    for(var key in options){
      $('.option-choices__entry[data-code="' + options[key].code + '"]').eq(0).addClass('selected');
      $('.product-options__entry[data-key="' + key + '"]').eq(0).find('.product-options__value').text(options[key].label);
      $('.product-options__entry[data-key="' + key + '"]').eq(0).find('.product-options__image img').attr('src', '/assets/images/configurator/' + key + '/' + options[key].code + '.jpg');
      $('[data-code$="' + options[key].code + '"] .product-options__checkbox').eq(0).find('input').trigger('click');
    }
  },
  initGallery: function() {
    if (Configurator.$gallery.find('.product-configurator__image').length > 1) {
      Configurator.$gallery.flickity({
        pageDots: true,
        wrapAround: true,
        draggable: true,
        prevNextButtons: true,
        arrowShape: arrowShape,
        selectedAttraction: 0.013,
        friction: 0.2
      });
      Configurator.$gallery.flickity('resize');
    }
    Configurator.update3DViewer(Configurator.getCode());

  },
  showSlideByCode: function (code){
    console.log('showSlideByCode: '+code);
    var index = $('.product-configurator__image').index($('[data-code="' + code + '"]'));
    index = index < 0 ? 0 : index;
    Configurator.$gallery.flickity( 'select', index );
  },
  update3DViewer: function (code){
    console.log('update3DViewer: ', code);
  },
  show: function() {
    Configurator.$modal.modal({
      backdrop: 'static'
    });
  },
  selectCheckbox: function($target) {
      console.log($target);
      var checked = $target.find('[type="checkbox"]').prop('checked');
      var index = checked ? 1 : 0;
      var data = {
        key: $target.data('key'),
        code: $target.data('code').split('|')[index],
        label: $target.data('label').split('|')[index],
        price: parseFloat($target.data('price').split('|')[index])
      };
      Configurator.options[data.key] = {
        code: data.code,
        label: data.label,
        price: data.price,
      };
      var price = Configurator.getPrice();
      if(Configurator.compact){
        Configurator.renderPagePrice(price);
      }else{
        Configurator.renderConfiguratorPrice(price);
      }
      Configurator.updateOption(data);
      Configurator.update3DViewer(Configurator.getCode());
  },
  initChoicesGrid: function() {
    Configurator.choicesGrid = $('.product-configurator:not(.product-configurator--compact) .option-choices__list').packery({
      itemSelector: '.option-choices__entry',
      transitionDuration: 0
    });
  },
  initChoicesCarousel: function() {
    Configurator.choicesCarousel = $('.option-choices__list').flickity({
      pageDots: false,
      prevNextButtons: false,
      cellAlign: 'left',
      contain: true,
      freeScroll: false
    });
  },
  showChoices: function($target) {
    $($target.data('target')).addClass('product-options__choices--open');
    Configurator.$configurator.addClass('product-configurator--selecting');
    
    if (Configurator.choicesGrid) {
      Configurator.choicesGrid.packery();
    }

    if (Configurator.choicesCarousel) {
      Configurator.choicesCarousel.flickity('resize');
    }

    if (Configurator.compact) {
      Configurator.$configurator.animate({scrollTop: 0}, 1);
    }
  },
  selectChoice: function($target) {
    $target.siblings().removeClass('selected');
    $target.addClass('selected');
    if(Configurator.compact){
      Configurator.applyChoice();
    }
    if (Configurator.choicesGrid) {
      Configurator.choicesGrid.packery();
    }
  },
  updateOption: function(data) {
    $('[data-key="' + data.key + '"] .product-options__value').text(data.label);
    $('[data-key="' + data.key + '"] .product-options__image img').prop('src', data.image);
  },
  applyChoice: function() {
    var $selectedChoice = $('.product-options__choices--open .option-choices__entry.selected');
    var data = {
      key: $selectedChoice.data('key'),
      code: $selectedChoice.data('code'),
      label: $selectedChoice.data('label'),
      price: parseFloat($selectedChoice.data('price')),
      image: $selectedChoice.find('img').prop('src')
    };
    // console.log($selectedChoice.data('key'));
    // if(data.key){
      Configurator.options[data.key] = {
        code: data.code,
        label: data.label,
        price: data.price
      };
      var price = Configurator.getPrice();
      if(Configurator.compact){
        Configurator.renderPagePrice(price);
      }else{
        Configurator.renderConfiguratorPrice(price);
      }
      Configurator.updateOption(data);
      Configurator.closeChoices();
      Configurator.update3DViewer(Configurator.getCode());
      // console.log(Configurator.options);
    // }else{
    //   console.warn('xxx');
    // }
  },
  closeChoices: function() {
    setTimeout(function(){
      $('.product-options__choices--open').removeClass('product-options__choices--open');
      $('.product-configurator--selecting').removeClass('product-configurator--selecting');
    }, 5);
  },
  applyConfigurations: function() {
    var price = Configurator.getPrice();
    Configurator.renderPagePrice(price);
    Configurator.updateProductIntroOptions();
    Configurator.close();
  },
  getPrice: function() {
    var optionsPrice = 0;
    for(var key in Configurator.options){
      optionsPrice += Configurator.options[key].price;
    }
    var total = parseFloat(Configurator.basePrice) + parseFloat(optionsPrice);
    var price = {
      total: total,
      discount: (total / 100) * Configurator.discount
    };

    return price;
  },
  getCode: function() {
    var optionsCode = [];
    for(var key in Configurator.options){
      optionsCode.push(Configurator.options[key].code);
    }
    var code = optionsCode.sort().join('');

    return code;
  },
  renderConfiguratorPrice: function(price) {
    // console.log(price);
    $('.product-configurator .product__full-price').html((price.total).toFixed(2) + ' €');
    $('.product-configurator .product__final-price').html((price.total - price.discount).toFixed(2) + ' €');
  },
  renderPagePrice: function(price) {
    // console.log(price);
    $('.product__full-price').html((price.total).toFixed(2) + ' €');
    $('.product__final-price').html((price.total - price.discount).toFixed(2) + ' €');
    var checkoutUrl = $('[data-configured-checkout-url]').data('configured-checkout-url');
    $('[data-configured-text]').text($('[data-configured-text]').data('configured-text')).attr('href', checkoutUrl);
    $('.product-intro__reconfigure').removeClass('hidden');
  },
  updateProductIntroOptions: function(){
    if(Configurator.compact) return false;
    $('.product__recap').empty().append('<ul class="recap-options"></ul>');
    $('.product-configurator .product-options__entry').each(function(){
      $this  = $(this);
      var label = $this.find('.product-options__caption')
      .clone()    //clone the element
      .children() //select all the children
      .remove()   //remove all the children
      .end()  //again go back to selected element
      .text();
      var text = $this.find('.product-options__value').text();
      var img = $this.find('.product-options__image img').attr('src');
      var value = img ? '<div class="recap-options__image"><img title="' + text + '" src="' + img + '"></div>' : '<span class="recap-options__text">' + text + '</span>';

      $('.product__recap ul').append('<li class="recap-options__item"><span class="recap-options__caption">' + label + '</span>' + value + '<button class="recap-options__edit" data-toggle="configure"><img src="/assets/images/ui/icn_edit.svg" alt="Modifica" /></button></li>');
    });
  },
  formatEuro: function(n){
    return n.toLocaleString("it-IT", { maximumFractionDigits: 2, minimumFractionDigits: 2 });
  },
  close: function() {
    $('.product-configurator__close').trigger('click');
  }

};